// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1GFCz","body-wrapper":"body-wrapper__39WXu","body":"body__5xQH7"};